/*
  Copyright (c) Epic Games, Inc. All Rights Reserved.
  CONTAINS AI GENERATED CODE.
*/

import { LogoListSectionFragment } from "@cosmos/hygraph-schema";

import {
	ResponsiveContainer,
	SectionContainer,
	LogoMarquee,
	SectionHeading,
	BackgroundContainer,
} from "@components/elements";
import { VStack } from "@panda/jsx";
import { css } from "@panda/css";

export interface LogoListSectionProps extends LogoListSectionFragment {
	className?: string;
}

export const LogoListSection = (props: LogoListSectionProps): React.JSX.Element | null => {
	const validHeading = Boolean(props?.config?.heading?.title || props?.config?.heading?.desc);
	const validContent = Boolean(props?.logos?.length);
	if (!validHeading && !validContent) return null;
	return (
		<BackgroundContainer
			bgAnimation={props?.config?.backgroundAnimation}
			bgImageAsset={props?.config?.backgroundImage}
			bgFullHeight={props?.config?.backgroundFullHeight}
			edsBackgroundColor={props?.config?.edsBackgroundColor}
		>
			<ResponsiveContainer className={props.className} disable={!props.disableMarquee}>
				<SectionContainer disablePaddingInline={!props.disableMarquee}>
					<VStack gap="eds.dimension.96" className="logo-list-section">
						{validHeading ? (
							<>
								<div className={css({ smDown: { paddingInline: "eds.dimension.24" } })}>
									<SectionHeading {...props?.config?.heading} />
								</div>
								<LogoMarquee {...props} />
							</>
						) : (
							<LogoMarquee {...props} />
						)}
					</VStack>
				</SectionContainer>
			</ResponsiveContainer>
		</BackgroundContainer>
	);
};
